import { Button, Modal } from 'antd';
import { Prompt, useHistory } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import OmniNotification from 'components/OmniNotification';
import { useTranslation } from 'react-i18next';

export interface confirmResultType {
	loading: boolean;
	result: boolean;
}

export interface IProps {
	when: boolean;
	confirmResult: confirmResultType;
	isFormValid: boolean;
	confirmHandler: Function;
}

export enum RouteLeavingGuardPagesName {
	ProjectDetails = 'Project Details',
	ProjectAssets = 'Project Assets',
}

export default function RouteLeavingGuard(props: IProps) {
	const { when, isFormValid, confirmHandler, confirmResult } = props;
	const { t } = useTranslation();
	const [modalVisible, setModalVisible] = useState<boolean>(false);
	const [ifCancelBlock, setIfCancelBlock] = useState<boolean>(false);
	const [nextRoute, setNextRoute] = useState<string>('');
	const history = useHistory();

	const handleBlockedNavigation = (location, action) => {
		if (ifCancelBlock) {
			return true;
		}
		setNextRoute(`${location.pathname}${location.search}`);
		setModalVisible(true);
		try {
			var sideMenuItemsArray = Array.from(
				document
					.querySelectorAll('.ant-menu-item-group-list')[1]
					.querySelectorAll('.ant-menu-item'),
			).slice(1);
			sideMenuItemsArray.forEach((element) => {
				(element as HTMLElement).style.color = '#262626';
				(element as HTMLElement).style.fontWeight = '400';
			});
		} catch {}
		return false;
	};

	useEffect(() => {
		if (!modalVisible) {
			setTimeout(() => {
				try {
					var sideMenuItemsArray = Array.from(
						document
							.querySelectorAll('.ant-menu-item-group-list')[1]
							.querySelectorAll('.ant-menu-item'),
					).slice(1);
					sideMenuItemsArray.forEach((element) => {
						(element as HTMLElement).classList.remove('ant-menu-item-active');
						(element as HTMLElement).removeAttribute('style');
					});
				} catch {}
			}, 500);
		}
	}, [modalVisible]);

	const handleDiscard = useCallback(() => {
		setModalVisible(false);
		setIfCancelBlock(true);
		setTimeout(() => {
			if (nextRoute) {
				history.push(nextRoute);
			}
		}, 0);
	}, [nextRoute]);

	const handleSaveChanges = useCallback(() => {
		if (!isFormValid) {
			setModalVisible(false);
			OmniNotification.info({
				message: t('form.confirmation.errorMessage.title'),
				description: t('form.confirmation.errorMessage.description'),
			});
			return;
		}

		confirmHandler();
	}, [isFormValid]);

	useEffect(() => {
		if (!confirmResult.loading && confirmResult.result) {
			setModalVisible(false);
			if (nextRoute) {
				setIfCancelBlock(true);
			}
			setTimeout(() => {
				if (nextRoute) {
					history.push(nextRoute);
				}
			}, 0);
		}
	}, [confirmResult, nextRoute]);

	return (
		<>
			<Prompt when={when} message={handleBlockedNavigation} />
			<Modal
				title={null}
				closable={true}
				visible={modalVisible}
				width={385}
				footer={[
					<Button key={'Discard'} onClick={handleDiscard}>
						{t('common.Discard')}
					</Button>,
					<Button
						key={'save'}
						type="primary"
						loading={confirmResult.loading}
						onClick={handleSaveChanges}
					>
						{t('common.SaveChanges')}
					</Button>,
				]}
				onCancel={() => {
					setNextRoute('');
					setModalVisible(false);
				}}
			>
				<div className="ant-modal-confirm-body">
					<InfoCircleOutlined
						style={{ color: '#FAAD14', fontSize: 22, marginRight: 16 }}
					/>
					<span className="ant-modal-confirm-title">
						<span>{t('form.confirmation.title')}</span>
					</span>
					<div className="ant-modal-confirm-content">
						<span>{t('form.confirmation.content')}</span>
					</div>
				</div>
			</Modal>
		</>
	);
}
